import { IdType, ImportType } from 'modules/domains/adminApp';

export const getDefaultChangelogComment = (idType: IdType, importType: ImportType) =>
  `${importType === ImportType.EnableFeature ? 'Enabled' : 'Disabled'} feature for all ${
    idType === IdType.Project ? 'project' : 'organization'
  } IDs`;
